<app-payment-gateway-working-english *ngIf="english"></app-payment-gateway-working-english>
<app-payment-gateway-working-hindi *ngIf="hindi"></app-payment-gateway-working-hindi>